export const textFieldShrink = (value: any, noCheckbox?: boolean) => {
  if (noCheckbox) {
    if (Boolean(value)) return { InputLabelProps: { shrink: true } };
    return {};
  }
  return { InputLabelProps: { shrink: Boolean(value) ? true : false } };
};
